export function Schedule(debounceTime, accumulator) {
    return function (target, fieldName, descriptor) {
        const originalMethod = descriptor.value;
        let accumulatorArgs = null;
        let timer = null;
        let pending = null;
        if (!originalMethod)
            throw new Error(`${fieldName} is undefined.`);
        descriptor.value = function (...args) {
            accumulatorArgs = accumulator(accumulatorArgs, args);
            if (pending)
                return pending;
            pending = new Promise((resolve, reject) => {
                if (timer)
                    clearTimeout(timer);
                timer = setTimeout(() => {
                    originalMethod
                        .apply(this, accumulatorArgs)
                        .then((result) => {
                        resolve(result);
                    })
                        .catch((error) => {
                        reject(error);
                    });
                    accumulatorArgs = null;
                    timer = null;
                    pending = null;
                }, debounceTime);
            });
            return pending;
        };
    };
}
//# sourceMappingURL=schedule.js.map